<div class="container" cdkFocusInitial aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1>Edit Authorized Treatment Funds</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="shade">
      <h2>TREATMENT DETAILS</h2>
      <div class="row">
        <div class="element-header" style="max-width: 120px;">Type:</div>
        <div class="element" style="max-width: 120px;">{{spec.type}}</div>
        <div class="element-header" style="max-width: 120px;">Treatment:</div>
        <div class="element-long">{{spec.treatment}}</div>
      </div>
      <div class="row">
        <div class="element-header">Implementation Spec. Name:</div>
        <div class="element">{{spec.spec_name}}</div>
      </div>
      <div class="row">
        <div class="element-header" style="max-width: 120px;">Off-NFS Land:</div>
        <div class="element" style="max-width: 120px;">
          {{spec.treatment_off_nfs_land ? "Yes": (spec.treatment_off_nfs_land === null? "--":"No")}}
        </div>
        <div class="element-header" style="max-width: 120px;">Outside Fire:</div>
        <div class="element">
          @if (spec.treatment == "P1b. Invasives EDRR - Suppression Repair") {
          N/A
          } @else if ((spec.from_GIS !== false) && (spec.treatment_outside_fire === null)) {
          Does Not Apply
          } @else {
          {{spec.treatment_outside_fire ? "Yes": (spec.treatment_outside_fire === null? "--":"No")}}
          }
        </div>
      </div>
      <div class="element-header">Treatment Narrative</div>
      @if (spec.treatment_narrative) {
      <mat-expansion-panel style="margin-bottom: 20px;">
        <mat-expansion-panel-header expandedHeight="100%" collapsedHeight="100px" style="align-items: start;">
          <p [innerHTML]="customATOB(spec.treatment_narrative || '--')" style="overflow-wrap: anywhere;"></p>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      }
      @if (spec.treatment_narrative == '') {
      <div>
        --
      </div>
      }
      @if (spec.specification_sheet) {
      <div class="row"><a [href]="decodeURI(spec.specification_sheet)" target="_blank" rel="noopener noreferrer">Spec.
          Sheet <fa-icon class="fa-sm" [icon]="faExternalLink"></fa-icon></a></div>
      }
      <h2>REQUESTED FUNDS</h2>
      <div class="row">
        <div class="element-wrapper">
          <div class="element-header">Unit Type</div>
          <div class="element">{{spec.unit_type}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header"># of Units</div>
          <div class="element">{{spec.unit_qty}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header">Unit Cost</div>
          <div class="element">{{spec.unit_cost | currency}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header">Total Requested</div>
          <div class="element">{{spec.unit_qty * spec.unit_cost | currency}}</div>
        </div>
      </div>
      @if(specForm.value.ro_authorized_by_id! == 2 && type == 'WO') {
      <h2>RO SPLIT AUTHORIZED FUNDS</h2>
      <div class="row">
        <div class="element-wrapper">
          <div class="element-header">Unit Type</div>
          <div class="element">{{spec.unit_type}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header"># of Units</div>
          <div class="element">{{spec.approved_unit_qty}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header">Unit Cost</div>
          <div class="element">{{spec.approved_unit_cost | currency}}</div>
        </div>
        <div class="element-wrapper">
          <div class="element-header">Total RO Authorized</div>
          <div class="element">{{spec.approved_unit_qty * spec.approved_unit_cost | currency}}</div>
        </div>
      </div>
      }
    </div>
    @if(this.type == 'RO') {
    <form id="spec_form" class="filter_form" [formGroup]="specForm">
      <div class="subtitle" style="margin-bottom: 10px;"><span class="red-normal">*</span>Indicates required field</div>
      <div class="header-subtext">
        <h2>Regional Authorized funds</h2>
        <p>Please review the requested funds for the specified treatment category and determine if it will be 'RO
          Authorized', 'Forwarded to the WO,' 'Split RO/WO authorization' or 'Not authorized.'</p>
      </div>
      <mat-form-field appearance="outline" class="half-field">
        <mat-label>Authorized By</mat-label>
        <mat-select formControlName="ro_authorized_by_id" (selectionChange)="selectedAuthorized($event)">
          <mat-option [value]="null">--</mat-option>
          @for (item of authorizedByList; track item) {
          <mat-option [value]="item.value">{{item.text}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @switch (specForm.value.ro_authorized_by_id!) {
      @case (0) {
      <!-- RO Authorized -->
      <div class="header-subtext">
        <div class="element-header">RO Authorized Funds</div>
        <p>Select 'Fully Funded' if you're approving the entire quantity at the present cost per unit. If you need to
          approve a different number of units or change the cost per unit, then adjust the amounts in the fields
          provided below.</p>
      </div>
      <div class="row">
        <mat-checkbox formControlName="fully_funded">
          <span style="font-size: 16px;">Fully Funded</span>
        </mat-checkbox>
      </div>
      <div class="shade">
        @if (!specForm.value.fully_funded!) {
        <div class="row" style="margin-bottom: -20px;">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element" style="padding-top: 10px;">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span># of Units</div>
            <div class="element">
              <mat-form-field required appearance="outline">
                <input required matInput aria-label="approved unit Quanity" formControlName="approved_unit_qty"
                  thousandSeparator="," mask="separator" decimalMarker=".">
                <mat-error>Lower the # of units</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span>Unit Cost</div>
            <div class="element">
              <mat-form-field appearance="outline">
                <input required prefix="$ " mask="separator.2" thousandSeparator="," decimalMarker="." matInput
                  aria-label="Unit Cost" formControlName="approved_unit_cost">
                <mat-error style="width: 500px;">Lower the unit cost</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element" style="padding-top: 10px;">{{unitTotal(specForm.value.approved_unit_qty,
              specForm.value.approved_unit_cost) |
              currency}}</div>
          </div>
        </div>
        } @else {
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span># of Units</div>
            <div class="element">{{spec.unit_qty}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span>Unit Cost</div>
            <div class="element">{{spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element">{{spec.unit_qty * spec.unit_cost | currency}}</div>
          </div>
        </div>
        }
      </div>
      @if (!specForm.value.fully_funded!) {
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for modifying the number of units or unit cost amounts.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      } @else {
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header">Authorization Note<span class="sub-header">(Optional)</span></div>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note"></textarea>
      </mat-form-field>
      }
      }
      @case(1) {
      <!-- Forward to WO -->
      <div class="header-subtext">
        <div class="element-header">RO Authorized Funds</div>
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Unit Cost</div>
            <div class="element" style="flex: 50%; max-width: 100%;">{{spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Authorized</div>
            <div class="element" style="flex: 50%; max-width: 100%;">--</div>
          </div>
        </div>
      </div>
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for forwarding the requested funds.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      }
      @case(2) {
      <!-- Split RO/WO Auth -->
      <div class="header-subtext">
        <div class="element-header"><span class="red-normal">*</span>RO Split Authorized Funds</div>
        <p>Update the <b># of Units</b> and/or <b>Unit Cost</b> to be authorized at the regional level. All other
          remaining units will be forwarded to the WO for approval.</p>
      </div>
      <div class="shade">
        <div class="row" style="margin-bottom: -20px;">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element" style="padding-top: 10px;">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span># of Units</div>
            <div class="element">
              <mat-form-field required appearance="outline">
                <input required matInput aria-label="approved unit Quanity" formControlName="approved_unit_qty"
                  thousandSeparator="," mask="separator" decimalMarker=".">
                <mat-error>Lower the # of units</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span>Unit Cost</div>
            <div class="element">
              <mat-form-field appearance="outline">
                <input required prefix="$ " mask="separator.2" thousandSeparator="," decimalMarker="." matInput
                  aria-label="Unit Cost" formControlName="approved_unit_cost">
                <mat-error style="width: 500px;">Lower the unit cost</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element" style="padding-top: 10px;">{{unitTotal(specForm.value.approved_unit_qty,
              specForm.value.approved_unit_cost) | currency}}</div>
          </div>
        </div>
      </div>
      <div class="header-subtext">
        <div class="element-header" style="margin-top:20px">WO Split Authorization</div>
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"># of Units</div>
            @if (type == 'RO') {
            <div class="element">{{spec.unit_qty - (specForm.value.approved_unit_qty ?? 0)}}</div>
            } @else {
            <div class="element">{{spec.wo_approved_unit_qty}}</div>
            }
          </div>
          <div class="element-wrapper">
            <div class="element-header">Unit Cost</div>
            @if (type == 'RO') {
            <div class="element">{{ spec.unit_cost | currency}}</div>
            } @else {
            <div class="element">{{spec.wo_approved_unit_cost}}</div>
            }
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element">{{unitTotal(spec.wo_approved_unit_qty, spec.wo_approved_unit_cost) | currency}}</div>
          </div>
        </div>
      </div>
      <div class="header-subtext" style="margin-top: 20px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for splitting the requested funds.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      }
      @case(4) {
      <!-- Not Authorized -->
      <div class="header-subtext">
        <div class="element-header">RO Authorized Funds</div>
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Unit Cost</div>
            <div class="element" style="flex: 50%; max-width: 100%;">{{spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Authorized</div>
            <div class="element" style="flex: 50%; max-width: 100%;">$0</div>
          </div>
        </div>
      </div>
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header" style="max-width: 100%;"><span class="red-normal">*</span>Authorization Status<span
            class="sub-header">(Select all that apply)</span></div>
      </div>
      <mat-form-field appearance="outline" style="margin-bottom: -20px;">
        <mat-select formControlName="authorization_status_id" multiple required>
          <mat-select-trigger>
            {{getAuthStatusText()}}
          </mat-select-trigger>
          @for (item of authorizationStatusList; track item) {
          <mat-option [value]="item.value">{{item.text}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="header-subtext" style="margin-top: 20px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for not authorizing the requested funds.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      }
      @default {
      <div class="header-subtext">
        <div class="element-header">RO Authorized Funds</div>
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"># of Units</div>
            <div class="element">{{spec.unit_qty}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Unit Cost</div>
            <div class="element">{{spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element">--</div>
          </div>
        </div>
      </div>
      }
      }
    </form>
    } @else {
    <!-- WO ----------------------------------------------------------------------------------------------->
    <form id="spec_form" class="filter_form" [formGroup]="specForm">
      <div class="subtitle" style="margin-bottom: 10px;"><span class="red-normal">*</span>Indicates required field</div>
      <div class="header-subtext">
        <h2>WO AUTHORIZED FUNDS</h2>
        <p>Please review the requested funds for the specified treatment category and determine if it will be 'WO
          Authorized' or 'Not authorized.'</p>
      </div>
      <mat-form-field appearance="outline" class="half-field">
        <mat-label>Authorized By</mat-label>
        <mat-select formControlName="wo_authorized_by_id" required (selectionChange)="selectedAuthorized($event)">
          <mat-option [value]="null">--</mat-option>
          @for (item of authorizedByListWO; track item) {
          <mat-option [value]="item.value">{{item.text}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @switch (specForm.value.wo_authorized_by_id!) {
      @case (3) {
      <!-- WO Authorized -->
      <div class="header-subtext">
        @if(specForm.value.ro_authorized_by_id! == 2) {
        <div class="element-header">WO Split Authorized Funds</div>
        } @else {
        <div class="element-header">WO Authorized Funds</div>
        }
        <p>Select 'Fully Funded' if you're approving the entire quantity at the present cost per unit. If you need to
          approve a different number of units, then adjust the amounts in the fields provided below.</p>
      </div>
      <div class="row">
        <mat-checkbox formControlName="wo_fully_funded">
          <span style="font-size: 16px;">Fully Funded</span>
        </mat-checkbox>
      </div>
      <div class="shade">
        @if (!specForm.value.wo_fully_funded!) {
        <div class="row" style="margin-bottom: -20px;">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element" style="padding-top: 10px;">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span># of Units</div>
            <div class="element">
              <mat-form-field required appearance="outline">
                <input required matInput aria-label="approved unit Quanity" formControlName="wo_approved_unit_qty"
                  thousandSeparator="," mask="separator" decimalMarker=".">
                <mat-error>Invalid Quantity</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span>Unit Cost</div>
            <div class="element">
              <mat-form-field appearance="outline">
                <input required prefix="$ " mask="separator.2" thousandSeparator="," decimalMarker="." matInput
                  aria-label="Unit Cost" formControlName="wo_approved_unit_cost">
              </mat-form-field>
            </div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element" style="padding-top: 10px;">{{unitTotal(specForm.value.wo_approved_unit_qty,
              specForm.value.wo_approved_unit_cost) |
              currency}}</div>
          </div>
        </div>
        } @else {
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span># of Units</div>
            <div class="element">{{this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0)}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"><span class="red-normal">*</span>Unit Cost</div>
            <div class="element">{{spec.approved_unit_cost ?? this.spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element">{{(this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0)) * (spec.approved_unit_cost
              ??
              this.spec.unit_cost) | currency}}</div>
          </div>
        </div>
        }
      </div>
      @if (!specForm.value.wo_fully_funded!) {
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for modifying the number of units or unit cost amounts.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      } @else {
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header">Authorization Note<span class="sub-header">(Optional)</span></div>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note"></textarea>
      </mat-form-field>
      }
      }
      @case(4) {
      <!-- Not Authorized -->
      <div class="header-subtext">
        @if(specForm.value.ro_authorized_by_id! == 2) {
        <div class="element-header">WO Split Authorized Funds</div>
        } @else {
        <div class="element-header">WO Authorized Funds</div>
        }
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Unit Cost</div>
            <div class="element" style="flex: 50%; max-width: 100%;">{{spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header" style="flex: 50%; max-width: 100%;">Authorized</div>
            <div class="element" style="flex: 50%; max-width: 100%;">$0</div>
          </div>
        </div>
      </div>
      <div class="header-subtext" style="margin-top: 10px;">
        <div class="element-header" style="max-width: 100%;"><span class="red-normal">*</span>Authorization Status<span
            class="sub-header">(Select all that apply)</span></div>
      </div>
      <mat-form-field appearance="outline" style="margin-bottom: -20px;">
        <mat-select formControlName="authorization_status_id" multiple required>
          <mat-select-trigger>
            {{getAuthStatusText()}}
          </mat-select-trigger>
          @for (item of authorizationStatusList; track item) {
          <mat-option [value]="item.value">{{item.text}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="header-subtext" style="margin-top: 20px;">
        <div class="element-header"><span class="red-normal">*</span>Authorization Note</div>
        <p>Add a brief reason for not authorizing the requested funds.</p>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="authorization_note" required></textarea>
      </mat-form-field>
      }
      @default {
      <div class="header-subtext">
        @if(specForm.value.ro_authorized_by_id! == 2) {
        <div class="element-header">WO Split Authorized Funds</div>
        } @else {
        <div class="element-header">WO Authorized Funds</div>
        }
      </div>
      <div class="shade">
        <div class="row">
          <div class="element-wrapper">
            <div class="element-header">Unit Type</div>
            <div class="element">{{spec.unit_type}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header"># of Units</div>
            <div class="element">{{this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0)}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Unit Cost</div>
            <div class="element">{{spec.approved_unit_cost ?? this.spec.unit_cost | currency}}</div>
          </div>
          <div class="element-wrapper">
            <div class="element-header">Authorized</div>
            <div class="element">--</div>
          </div>
        </div>
      </div>
      }
      }
    </form>
    }
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row">
      <button aria-label="Close" class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button aria-label="Save" class="usa-button" [disabled]="!specForm.valid" (click)="editFunds()">Save</button>
    </div>
  </div>
</div>